import React, { useContext, useEffect, useRef } from 'react'
import styles from "../css/UserMenu.module.css"
import { FiSettings, FiLogOut } from "react-icons/fi";
import { PageContext } from './Notes';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../actions/authActions';
import { toast } from 'react-toastify';

const UserMenu = ({closeMenu}) => {
  const menuRef = useRef(null)
  const [,setPageModals] = useContext(PageContext)
  const user = useSelector((state)=>state.authState.user)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(()=>{
    const handleClick = (e) => {
      if (!menuRef.current.parentNode.contains(e.target))
        closeMenu()
    }

    window.addEventListener("mousedown",handleClick)
    return () => {
      window.removeEventListener("mousedown",handleClick)
    }
  },[closeMenu])

  const handle = () => {
    toast.dismiss()
    setPageModals((prevState)=>{return {...prevState,settings:true}})
    closeMenu()
  }

  const handleLogout = async() => {
    dispatch(logout()).finally(()=>navigate("/login"))
  }

  return (
      <div data-testid = "user-menu" className={styles.menu} ref = {menuRef}>
        <div className={styles.profile}>
          <div className={styles.avatar}>{user.fullname?.charAt(0).toUpperCase()}</div>
          <div className={styles.name}>{user.fullname}</div>
          <div className={styles.email}>{user.email}</div>
        </div>

        <div className={styles.items}>
          <button data-testid = "settings-btn" className={styles.item} onClick = {()=>handle()}>
            <div className={styles.itemIcon}>
              <FiSettings />
            </div>
            <div className={styles.itemLabel}>Manage Settings</div>
          </button>
          <div className={styles.divider}></div>
          <button data-testid = "logout-btn" className={`${styles.item} ${styles.danger}`} onClick = {()=>handleLogout()}>
            <div className={styles.itemIcon}>
              <FiLogOut />
            </div>
            <div className={styles.itemLabel}>Logout</div>
          </button>
        </div>
      </div>
  )
}

export default UserMenu